<div class="flex w-full place-content-start place-items-baseline gap-5 md:place-content-center">
  @if (displayFilterByTitle()) {
    <span class="text-xl leading-6 text-[#1E1E1E]">{{ 'Search.filter' | translate }}</span>
  }
  <button #origin="cdkOverlayOrigin" cdkOverlayOrigin (click)="openCloseOverlay()"
          class="!justify-between !px-[1.25rem] !py-[0.75rem] !text-[1.25rem] !leading-[1.5rem] !gap-[0.44rem] shadow-[0_6px_14px_2px_rgba(93,95,133,0.20)] min-h-[3rem]"
          type="button"
          shButton
          [ngClass]="buttonCustomClass()" [attr.aria-expanded]="isOpen()"
  >
    <span class="overflow-hidden whitespace-nowrap overflow-ellipsis flex-1 text-start" outline color="blue">{{ placeholder() }}</span>
    @if (selected().length > 0) {
      ({{ selected().length }})
    }
    <span
      class="flex h-6 w-6 origin-center rotate-0 place-content-center place-items-center transition-transform"
      [ngClass]="{ 'rotate-180': isOpen() }"
    >
      <sheba-arrow-down-icon />
    </span>
  </button>
</div>

<ng-template
  #overlay="cdkConnectedOverlay"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="['opacity-1']"
  [cdkConnectedOverlayDisableClose]="false"
  [cdkConnectedOverlayPush]="false"
  [cdkConnectedOverlayFlexibleDimensions]="false"
  [cdkConnectedOverlayGrowAfterOpen]="false"
  [cdkConnectedOverlayViewportMargin]="8"
  [cdkConnectedOverlayWidth]="overlayWidth()"
  (detach)="onCloseMenu()"
  (backdropClick)="onCloseMenu()"
  cdkConnectedOverlay
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
>
  <div
    class="flex flex-col overflow-hidden rounded-3xl bg-white shadow-[0px_2px_6px_2px_rgba(93,95,133,0.30)]"
    [ngClass]="{ 'w-full': matchButtonWidth() }"
  >
    <div
      class="flex h-[22.1875rem] md:w-[26.25rem] max-h-[calc(100vh-18rem)] flex-col gap-5 px-[1.875rem] py-5"
      [ngClass]="[popupCustomClass() || '']"
      [cdkTrapFocusAutoCapture]="false"
      cdkTrapFocus
    >
      <div class="flex place-content-between place-items-baseline">
        <span class="w-0 flex-grow truncate text-xl leading-[1.875rem] text-[#777680]">{{ filterTitle() }}</span>

        <button #clearButton (click)="clearSelection(); onCloseMenu()" shButton color="black" small>
          {{ 'SHARED.CLEAR_SELECTION' | translate }}
        </button>
      </div>
      <form class="-ms-3 overflow-y-auto scrollbar-thin scrollbar-track-[#BDC8D21A] scrollbar-thumb-[#3B3B3F] multi-select-scroll-area">
        <ul class="flex flex-col gap-1">
          @for (option of options(); track $index) {
            @if (option.name) {
              <li>
                <mat-checkbox
                  class="sh-mat-checkbox"
                  [ngClass]="{'border-2 border-[#5f5e62] rounded-2xl pe-1' : $index === focusedIndex()}"
                  [ngModel]="isSelected(option)"
                  [ngModelOptions]="{standalone: true}"
                  [disabled]="isMaxSelected() && !isSelected(option)"
                  (ngModelChange)="onSelectChange($event, option)"
                  tabindex="0"
                >
                  <span class="font-['Simpler'] text-xl">{{ option.name }}</span>
                </mat-checkbox>
              </li>
            }
          }
        </ul>
      </form>
    </div>
    @if (isMaxSelected()) {
      <div class="flex w-full place-content-center place-items-center rounded-b-2xl bg-[#DFE0FF] px-[1.875rem] py-7">
        <span class="w-0 flex-grow truncate text-center text-xl font-normal text-[#1E1E1E] md:text-2xl">
          {{ 'SHARED.MAX_SELECTION_LIMIT' | translate }}
        </span>
      </div>
    }
  </div>
</ng-template>
